import firebase from 'firebase/app'
import Vue from "vue";
import Router from "vue-router";
import Login from "../views/Login.vue";
import Main from "../views/Main.vue";

import RequestList from "../components/RequestList.vue";
import VisitList from "../components/VisitList.vue";
import NotificationList from "../components/NotificationList.vue";
import NotificationDetail from "../components/NotificationDetail.vue";
import RequestDetail from "../components/RequestDetail.vue";
import BudgetList from "../components/BudgetList.vue";
import BudgetDetail from "../components/BudgetDetail.vue";
import ChargeList from "../components/ChargeList.vue";
import ChargeDetail from "../components/ChargeDetail.vue";
import ChatDetail from "../components/ChatDetail.vue";

import store from '../store'

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: "*",
      redirect: "/login"
    },
    {
      path: "/",
      redirect: "/login"
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/main",
      component: Main,
      meta: { requiresAuth: true },
      children: [
        {
          path: "",
          redirect: "request-list"
        },
        {
          path: "request-list",
          name: "request-list",
          component: RequestList,
          meta: { requiresAuth: true }
        },
        {
          path: "visit-list",
          name: "visit-list",
          component: VisitList,
          meta: { requiresAuth: true }
        },
        {
          path: "notification-list",
          name: "notification-list",
          component: NotificationList,
          meta: { requiresAuth: true }
        },
        {
          path: "notification-detail",
          name: "notification-detail",
          component: NotificationDetail,
          meta: { requiresAuth: true }
        },
        {
          path: "request-detail",
          name: "request-detail",
          component: RequestDetail,
          meta: { requiresAuth: true }
        },
        {
          path: "budget-list",
          name: "budget-list",
          component: BudgetList,
          meta: { requiresAuth: true }
        },
        {
          path: "budget-detail",
          name: "budget-detail",
          component: BudgetDetail,
          meta: { requiresAuth: true }
        },
        {
          path: "charge-list",
          name: "charge-list",
          component: ChargeList,
          meta: { requiresAuth: true }
        },
        {
          path: "charge-detail",
          name: "charge-detail",
          component: ChargeDetail,
          meta: { requiresAuth: true }
        },
        {
          path: "chat-detail",
          name: "chat-detail",
          component: ChatDetail,
          meta: { requiresAuth: true }
        }
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const mobsUser = process.env.VUE_APP_IS_MOBS;
  const signWithLink = store.getters.signWithLink

  if (requiresAuth && !currentUser) {
    next("login");
  } else if (currentUser) {
    next()
  } else if (!requiresAuth && currentUser && mobsUser === "true") {
    next({ name: "visit-list" });
  } else if (!requiresAuth && currentUser) {
    next({ name: "request-list" });
  } else {
    next()
  }
});

export default router;
